import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Tabs, Tab, Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { getListAPI as getPharmaorderList } from 'components/pharmaorder/PharmaorderAPI';
import { getListAPI as getProductList } from 'components/product/ProductAPI';
import { openDrawer } from './../../../store/slice/MenuSlice';
import ManageProductsProduct from '../action/manageProducts/ManageProductsProduct';
import PharmaorderInfo from '../PharmaorderInfo';
import PharmaorderInfoImpl from '../PharmaorderInfoImpl';
import { setProductDashboardProductList, setPharmaorderList, setProductList, setPharmaorderDashboardPharmaorderList } from 'store/slice/PharmaSlice';
import { deleteInfo } from 'store/slice/HeaderSlice';
import { callGetAPI } from 'api/ApiUtils';

import ProductDashboard from 'components/product/ProductDashboard';
import PharmaorderDashboard from '../PharmaorderDashboard';
import { useNavigate } from "react-router-dom";
import { setSelectedPharmaorderId, setPharmaorderAddorderModal } from 'store/slice/PharmaSlice';
import PharmaorderFilterCriteriaImpl from '../PharmaorderFilterCriteriaImpl';

export default function PharmaorderPageContainer({orderStatus}) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { productList, pharmaorderList } = useSelector((state) => state.pharmaslice);
    const { pharmaorderObj, submitorderModalOpen } = useSelector((state) => state.pharmaslice.pharmaorderDashboard);
    const { exchange, userprofileInfo } = useSelector((state) => state.headerslice);
    
    const [tabValue, setTabValue] = useState(1);

    const getPharmaorderListSuccess = (list) => { dispatch(setPharmaorderList(list)); }
    const getProductListSuccess = (list) => { dispatch(setProductList(list)); }

    const loadCurrentOrders = () => {
        callGetAPI("https://api.mypharmafactory.com/extn/pharmaorders/current",
                    ()=>{},
                    (orderList)=>{
                        dispatch(setPharmaorderList(orderList));
                       // setLoading(false);
                    },
                    (errorMsg)=>{
                        console.error("Error fetching orders by tag:", errorMsg);
                       // setLoading(false);
                    }
        );
    };


    useEffect(() => {
        if (orderStatus === 'current')
            loadCurrentOrders();

        // getPharmaorderList(() => { }, getPharmaorderListSuccess);
        // getProductList(() => { }, getProductListSuccess);
        // dispatch(openDrawer({drawerOpen: true}));
    }, []);
    useEffect(() => {
        if (tabValue === 0) {
            const filteredList = pharmaorderList.filter(order => 
                order.createdby === userprofileInfo.userid && 
                order.orderstatus !== 'CANCELLED' && 
                order.orderstatus !== 'ON_HOLD'
            );
            dispatch(setPharmaorderDashboardPharmaorderList(filteredList));
        } else if (tabValue === 1) {
            const filteredList = pharmaorderList.filter(order => 
                order.orderstatus !== 'CANCELLED' && 
                order.orderstatus !== 'ON_HOLD'
            );
            dispatch(setPharmaorderDashboardPharmaorderList(filteredList));
        }
    }, [tabValue])



    // Filter orders for "My Orders" tab
    const myOrders = pharmaorderList.filter(order => order.createdby === userprofileInfo.userid);

    const createPharmaorder = () => {
        dispatch(setSelectedPharmaorderId(-1));
        //dispatch(setShowEditForPharmaorder(true));
        dispatch(setPharmaorderAddorderModal(true));
    }
    return (
        <>

            <Grid container direction="column" sx={{ width:'100%', }}>
                <Grid item lg={12}>
                    <Grid container direction="row" sx={{ width:'100%', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Grid item lg={3} sx={{}}>
                            <Tabs value={tabValue} onChange={(_, newValue) => setTabValue(newValue)}>
                                <Tab label="My Orders" />
                                <Tab label="All Orders" />
                            </Tabs>
                        </Grid>
                        <Grid item lg={7} sx={{width:'100%'}}>
                            <PharmaorderFilterCriteriaImpl />
                        </Grid>
                        <Grid item lg={2} >
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => createPharmaorder()}
                                sx={{ ml: 2 }}
                                startIcon={<AddIcon />}
                            >
                                Add Order
                            </Button>
                        </Grid>
                    </Grid>

                </Grid>
                <Grid item lg={12} sx={{width:'100%'}}>
                    {tabValue === 0 ? (
                        <PharmaorderDashboard />
                    ) : (
                        <PharmaorderDashboard />
                    )}
                </Grid>



            </Grid>
            
        </>
    )
}